import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  API_HOST = environment.API_HOST;
  API_BASE = `${environment.API_HOST}/commerce`
  ASSETS_HOST = `${environment.API_ASSETS_HOST}`;
  static readonly URL_VALIDATION_PATTERN = '^(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$';
  static readonly MOBILE_VALIDATION_PATERN = '[0-9]{10}$';

  constructor() { }
}
